module.exports = __webpack_public_path__ + "media/images/icon__predict@2x-bcec3f910c3647e6b21a22f356ca561d.png";